import site_logo from "../asstes/logo/logo.png";
import short_logo from "../asstes/logo/shortLogo.png";
export const logo = site_logo;
export const shortLogo = short_logo;
export const title = 'HeyPrompt';
export const website = 'heyprompt.online';   
export const websiteUrl = 'https://heyprompt.online/';
export const currency = '₹';